import { Plus, Minus, Pencil, Trash2, History, AlertTriangle, MapPin } from "lucide-react";
import { money } from "@/lib/shop";

export const PartRow = ({ part: p, owner, onStock, onEdit, onDelete, onHistory, highlight }) => (
  <div className={`bg-white rounded-xl border p-4 grid gap-3 md:grid-cols-[1fr_auto] md:items-center ${p.low_stock ? "border-amber-300" : "border-slate-200"} ${highlight ? "ring-2 ring-brand" : ""}`} data-testid={`part-row-${p.id}`}>
    <div className="min-w-0">
      <div className="flex flex-wrap items-center gap-2">
        <p className="font-bold text-ink">{p.name}</p>
        <span className="rounded-full bg-slate-100 px-2.5 py-0.5 text-xs font-semibold text-slate-700">{p.category}</span>
        {p.low_stock && <span className="inline-flex items-center gap-1 rounded-full bg-amber-100 px-2.5 py-0.5 text-xs font-bold text-amber-800" data-testid={`part-low-badge-${p.id}`}><AlertTriangle className="h-3 w-3" /> Low stock</span>}
      </div>
      <p className="mt-1 text-sm text-slate-600 truncate">
        {[p.brand, p.compatible_model].filter(Boolean).join(" · ") || "—"}
      </p>
      <p className="mt-1 text-xs text-slate-500 flex flex-wrap gap-x-3">
        {p.location && <span className="inline-flex items-center gap-1"><MapPin className="h-3 w-3" />{p.location}</span>}
        {p.supplier && <span>Supplier: {p.supplier}</span>}
        {p.barcode && <span>Code: {p.barcode}</span>}
        <span>Price: {money(p.selling_price)}</span>
        {owner && <span data-testid={`part-cost-${p.id}`}>Cost: {money(p.purchase_cost)}</span>}
        {owner && p.unit_profit != null && <span className="font-semibold text-emerald-700">Profit: {money(p.unit_profit)}</span>}
      </p>
    </div>
    <div className="flex items-center gap-2">
      <div className="text-center mr-2">
        <p className={`font-display text-2xl font-black ${p.low_stock ? "text-amber-700" : "text-ink"}`} data-testid={`part-qty-${p.id}`}>{p.quantity}</p>
        <p className="text-[10px] uppercase tracking-wider text-slate-400">min {p.min_stock}</p>
      </div>
      <IconBtn onClick={() => onStock(p, "in")} label="Add stock" testid={`part-add-stock-${p.id}`} cls="bg-emerald-600 text-white hover:bg-emerald-700"><Plus className="h-4 w-4" /></IconBtn>
      <IconBtn onClick={() => onStock(p, "out")} label="Remove stock" testid={`part-remove-stock-${p.id}`} cls="bg-ink text-white hover:bg-brand"><Minus className="h-4 w-4" /></IconBtn>
      <IconBtn onClick={() => onHistory(p)} label="History" testid={`part-history-${p.id}`}><History className="h-4 w-4" /></IconBtn>
      {owner && <IconBtn onClick={() => onEdit(p)} label="Edit" testid={`part-edit-${p.id}`}><Pencil className="h-4 w-4" /></IconBtn>}
      {owner && <IconBtn onClick={() => onDelete(p)} label="Delete" testid={`part-delete-${p.id}`} cls="text-red-600 hover:bg-red-50"><Trash2 className="h-4 w-4" /></IconBtn>}
    </div>
  </div>
);

const IconBtn = ({ children, onClick, label, testid, cls = "hover:bg-slate-100" }) => (
  <button onClick={onClick} aria-label={label} title={label} className={`h-9 w-9 grid place-items-center rounded-full transition-colors ${cls}`} data-testid={testid}>{children}</button>
);
